import * as React from "react";
import type { SVGProps } from "react";
const SvgAnnotationTyping = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M7.2 9.69V9.6m4.8.09V9.6m4.8.09V9.6m-2.191 6.991L12 21.6l-2.4-5.009H4.8a2.4 2.4 0 0 1-2.4-2.4V4.8a2.4 2.4 0 0 1 2.4-2.4h14.4a2.4 2.4 0 0 1 2.4 2.4v9.391a2.4 2.4 0 0 1-2.4 2.4z"
    />
  </svg>
);
export default SvgAnnotationTyping;
